import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CustomDataGrid from '../../../../../../shared/components/CustomDataGrid';
import { handleError } from '../../../../../../shared/functions/handleError';
import { useAttendanceColumns } from '../../../../../../shared/hooks/useAttendanceColumns';
import { usePagination } from '../../../../../../shared/hooks/usePagination';
import { IAttendance } from '../../../../../../shared/interfaces/attendance/IAttendance';
import { AdminAttendanceService } from '../../../../attendance/service';

const AttendanceTab = () => {
  const { id } = useParams();
  const [data, setData] = useState<IAttendance[] | undefined>(undefined);
  const {
    pagination,
    setPagination,
    count,
    setCount,
    totalPages,
    setTotalPages,
  } = usePagination({
    perPage: 5,
  });

  const columns = useAttendanceColumns(
    () => {},
    () => {},
    true,
  );
  useEffect(() => {
    !!id &&
      AdminAttendanceService.getAll({
        ...pagination,
        page: pagination?.page + 1,
        userId: id,
      })
        .then((response) => {
          const list = response?.data;
          setCount(response?.count);
          setTotalPages(Math.ceil(response?.count / response?.perPage));
          setData(list);
        })
        .catch((err) => handleError(err));
  }, [pagination, setCount, setTotalPages, id]);
  return (
    <Box>
      <CustomDataGrid
        hasNextPage={totalPages < pagination?.page}
        rows={data || []}
        columns={columns}
        rowCount={count}
        pagination={pagination}
        setPagination={setPagination}
        loading={data === undefined}
      />
    </Box>
  );
};

export default AttendanceTab;
